import {inject, Injectable} from '@angular/core';
import {ChatsQueryParams} from "../types/telegram-page.types";
import {TelegramAccountsService} from "./telegram-accounts.service";
import {ChatTelegram} from "../types/chat-telegram.types";

@Injectable({
  providedIn: 'root'
})
export class TelegramPageService {
  private telegramAccountsService: TelegramAccountsService = inject(TelegramAccountsService);

  public setChatsQueryParams(): ChatsQueryParams {
    return {
      accountId: this.telegramAccountsService.selectedAccount().accountId,
      limit: 200
    };
  }

  public hasChatsChanged(newChats: Array<ChatTelegram>, oldChats: Array<ChatTelegram>): boolean {
    if (!newChats || !oldChats) { return true; }

    if (newChats.length !== oldChats.length) { return true; }

    return newChats.some((newChat) => {
      const oldChat = oldChats.find(i => i.id === newChat.id);

      return (
        newChat.unreadCount !== oldChat?.unreadCount
      );
    });
  }
}
